import React from 'react';
import { GitBranch, RefreshCw, X } from 'lucide-react';
import VersionHistory from '../VersionHistory';

const VersionHistorySidebar = ({
  showVersionsDropdown,
  setShowVersionsDropdown,
  versionHistoryRef,
  surveyId,
  setScreens,
  setDeviceMode,
  setCurrentScreenIndex,
  setSelectedElement,
  clearHistory,
  runWithoutUndo,
}) => {
  if (!showVersionsDropdown) return null;

  const handleRestoreVersion = async (restoredVersion) => {
    if (restoredVersion?.configuration?.screens) {
      const nextScreens = restoredVersion.configuration.screens;
      const nextDeviceMode = restoredVersion.configuration.deviceMode;
      clearHistory?.();
      const apply = () => {
        setScreens(nextScreens);
        if (nextDeviceMode) {
          setDeviceMode(nextDeviceMode);
        }
        if (typeof setCurrentScreenIndex === 'function') {
          setCurrentScreenIndex((idx) =>
            Math.min(idx, Math.max(0, nextScreens.length - 1))
          );
        }
        setSelectedElement?.(null);
      };
      if (typeof runWithoutUndo === 'function') {
        runWithoutUndo(apply);
      } else {
        apply();
      }
      alert('Version restored successfully! The screens have been updated.');
      setShowVersionsDropdown(false);
    }
  };

  const handleRefresh = () => {
    if (versionHistoryRef.current?.refresh) {
      versionHistoryRef.current.refresh();
    }
  };

  return (
    <div className="w-96 bg-white dark:bg-gray-800 border-l border-gray-200 dark:border-gray-700 flex flex-col shadow-2xl dark:shadow-gray-900/20 z-30">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900">
        <h3 className="text-sm font-semibold text-gray-800 flex items-center gap-2">
          <GitBranch className="w-4 h-4" />
          Version History
        </h3>
        <div className="flex items-center gap-1">
          <button
            onClick={handleRefresh}
            className="p-1 text-gray-500 hover:text-primary-600 hover:bg-primary-50 rounded transition-colors"
            title="Refresh versions"
          >
            <RefreshCw className="w-4 h-4" />
          </button>
          <button
            onClick={() => setShowVersionsDropdown(false)}
            className="p-1 text-gray-500 hover:text-primary-600 hover:bg-primary-50 rounded transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        <VersionHistory
          ref={versionHistoryRef}
          surveyId={surveyId}
          currentVersion={null}
          onRestoreVersion={handleRestoreVersion}
        />
      </div>
    </div>
  );
};

export default VersionHistorySidebar;
